<template>
    <div class="row mb-3">
        <div class="col-12">
            <div class="border-light b-radius-20 p-4">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb- pt-2 mt-1">
                        <div>
                            <strong
                                ><a href="https://www.sendcloud.fr/" class="text-dark" target="_blank">{{
                                    $tl("labels.clickAndCollect.sendcloud.title")
                                }}</a>
                            </strong>
                        </div>
                        <div>
                            <button @click="showTuto = !showTuto" class="btn btn-sm btn-success btn-circle">
                                {{ $tl("labels.clickAndCollect.sendcloud.integrationInfo") }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mt-2 mb-3">
                    <!-- <div class="col-12 pointer" @click="showTuto = !showTuto">Voir le tutoriel d'intégration</div> -->
                    <div class="col-12 border-light p-4" v-if="showTuto">
                        <ol class="list-style-inherit m-0">
                            <li>
                                {{ $tl("labels.clickAndCollect.sendcloud.tutorial.step1") }}
                                <a href="https://panel.sendcloud.sc/accounts/signup/" target="_blank"
                                    ><strong>{{ $tl("labels.clickAndCollect.sendcloud.title") }}</strong></a
                                >.
                            </li>
                            <li>
                                {{ $tl("labels.clickAndCollect.sendcloud.tutorial.step2") }}
                                <a href="https://panel.sendcloud.sc/#/settings/integrations/api/add" target="_blank"
                                    ><strong>{{ $tl("labels.clickAndCollect.sendcloud.tutorial.thisLink") }}</strong></a
                                >
                                :
                                <ul class="list-style-inherit m-0">
                                    <li>{{ $tl("labels.clickAndCollect.sendcloud.tutorial.substep2_1") }}</li>
                                    <li>{{ $tl("labels.clickAndCollect.sendcloud.tutorial.substep2_2") }}</li>
                                    <li>
                                        {{ $tl("labels.clickAndCollect.sendcloud.tutorial.substep2_3") }}
                                    </li>
                                    <li>
                                        {{ $tl("labels.clickAndCollect.sendcloud.tutorial.substep2_4") }}
                                    </li>
                                    <li>{{ $tl("labels.clickAndCollect.sendcloud.tutorial.substep2_5") }}</li>
                                </ul>
                            </li>
                            <li>
                                {{ $tl("labels.clickAndCollect.sendcloud.tutorial.step3") }}
                            </li>
                            <li>
                                {{ $tl("labels.clickAndCollect.sendcloud.tutorial.step4") }}
                                <ul class="list-style-inherit m-0">
                                    <li>
                                        {{ $tl("labels.clickAndCollect.sendcloud.tutorial.step4_1") }}
                                        <a href="https://panel.sendcloud.sc/#/settings/addresses/sender/add" target="_blank"
                                            ><strong>{{ $tl("labels.clickAndCollect.sendcloud.tutorial.thisLink") }}</strong></a
                                        >
                                    </li>
                                    <li>
                                        {{ $tl("labels.clickAndCollect.sendcloud.tutorial.step4_2") }}
                                        <a href="https://panel.sendcloud.sc/#/settings/financial/payments/direct-debit" target="_blank"
                                            ><strong>{{ $tl("labels.clickAndCollect.sendcloud.tutorial.thisLink") }}</strong></a
                                        >
                                    </li>
                                </ul>
                            </li>
                            <li>
                                {{ $tl("labels.clickAndCollect.sendcloud.tutorial.step5") }}
                                <a href="https://panel.sendcloud.sc/#/settings/integrations/manage" target="_blank"
                                    ><strong>{{ $tl("labels.clickAndCollect.sendcloud.tutorial.editShop") }}</strong></a
                                >
                                {{ $tl("labels.clickAndCollect.sendcloud.tutorial.link") }}
                            </li>
                        </ol>
                    </div>
                </div>
                <div class="row mt-1 mb-2">
                    <div class="col-md-5">{{ $tl("labels.clickAndCollect.sendcloud.publicKey") }}</div>
                    <div class="col-md-7">
                        <input type="text" v-model="sendcloud_public_key_" class="form-control" />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-5">{{ $tl("labels.clickAndCollect.sendcloud.privateKey") }}</div>
                    <div class="col-md-7">
                        <input type="text" v-model="sendcloud_private_key_" class="form-control" />
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-5">{{ $tl("labels.clickAndCollect.sendcloud.baseWeight") }}</div>
                    <div class="col-md-7">
                        <input type="number" v-model="base_weight_" class="form-control w-auto d-inline-block" /><span class="ms-2">{{
                            $tl("labels.clickAndCollect.sendcloud.grams")
                        }}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-5">{{ $tl("labels.clickAndCollect.sendcloud.minOrderAmount") }}</div>
                    <div class="col-md-7">
                        <input type="number" v-model="dispatch_min_amount_" class="form-control w-auto d-inline-block" /><span class="ms-2">€</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-5">{{ $tl("labels.clickAndCollect.sendcloud.freeShippingAbove") }}</div>
                    <div class="col-md-7">
                        <input type="number" v-model="dispatch_free_above_" class="form-control w-auto d-inline-block" /><span class="ms-2">€</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-5 pt-1">
                        <label class="form-label">{{ $tl("labels.clickAndCollect.sendcloud.relayPoints") }}</label>
                    </div>
                    <div class="col-md-7 pt-1">
                        <div class="d-inline-block align-middle lead-switch">
                            <input type="checkbox" class="switch align-self-center is-rounded" v-model="enable_service_points_" />
                            <label class="form-label" @click="enable_service_points_ = !enable_service_points_"></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showTuto: false,
        };
    },
    props: {
        sendcloud_public_key: {
            default: null,
        },
        sendcloud_private_key: {
            default: null,
        },
        base_weight: {
            default: null,
        },
        dispatch_min_amount: {
            default: null,
        },
        dispatch_free_above: {
            default: null,
        },
        enable_service_points: {
            default: false,
        },
    },
    computed: {
        sendcloud_public_key_: {
            get() {
                return this.sendcloud_public_key;
            },
            set(newVal) {
                this.$emit("sendcloud-public-key", newVal);
            },
        },
        sendcloud_private_key_: {
            get() {
                return this.sendcloud_private_key;
            },
            set(newVal) {
                this.$emit("sendcloud-private-key", newVal);
            },
        },
        base_weight_: {
            get() {
                return this.base_weight;
            },
            set(newVal) {
                this.$emit("base-weight", newVal);
            },
        },
        dispatch_min_amount_: {
            get() {
                return this.dispatch_min_amount ? this.dispatch_min_amount / 100 : this.dispatch_min_amount;
            },
            set(newVal) {
                this.$emit("dispatch-min-amount", newVal ? newVal * 100 : newVal);
            },
        },
        dispatch_free_above_: {
            get() {
                return this.dispatch_free_above ? this.dispatch_free_above / 100 : this.dispatch_free_above;
            },
            set(newVal) {
                this.$emit("dispatch-free-above", newVal ? newVal * 100 : newVal);
            },
        },
        enable_service_points_: {
            get() {
                return this.enable_service_points;
            },
            set(newVal) {
                this.$emit("enable-service-points", newVal);
            },
        },
    },
    methods: {},
};
</script>

<style scoped>
ol.list-style-inherit > li,
ul.list-style-inherit > li {
    list-style: inherit !important;
}
</style>
